import React from 'react';
import { Leaf, Recycle, PiggyBank, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const BENEFITS = [
  { icon: Recycle, title: 'Menos plástico', text: 'Cada bolsa refill evita tirar un envase nuevo a la basura.' },
  { icon: PiggyBank, title: 'Ahorras más', text: 'Pagas solo por el producto, no por un envase nuevo.' },
  { icon: Leaf, title: 'La misma fórmula', text: 'Nuestros productos de siempre, 100% naturales y a base de miel.' },
];

const goToRefill = () => {
  window.dispatchEvent(new CustomEvent('selectCategory', { detail: 'Refill' }));
  document.getElementById('productos')?.scrollIntoView({ behavior: 'smooth' });
};

export const RefillSection = () => (
  <section id="cuida-el-planeta" data-testid="refill-section" className="py-20 bg-[#f4f1e8] overflow-hidden">
    <div className="container mx-auto px-4 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div className="relative order-2 lg:order-1 h-[420px] sm:h-[480px]">
        <img
          src="/images/refill.jpg"
          alt="Bolsas refill de Burbujas de mami"
          className="absolute left-0 top-0 w-[72%] aspect-square object-cover rounded-3xl shadow-xl"
          data-testid="refill-section-image-main"
        />
        <img
          src="/images/shampoo-acondicionador-1l.jpg"
          alt="Shampoo y acondicionador de miel de 1 litro"
          className="absolute right-0 bottom-0 w-[52%] aspect-square object-cover rounded-3xl shadow-2xl border-8 border-[#f4f1e8]"
          data-testid="refill-section-image-secondary"
        />
      </div>

      <div className="order-1 lg:order-2">
        <span className="inline-flex items-center gap-2 text-sm font-medium text-emerald-800 bg-emerald-100/70 px-4 py-1.5 rounded-full mb-5">
          <Leaf className="w-4 h-4" /> Cuida el planeta
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-honey-950 mb-5 leading-tight">
          Recarga tu envase en lugar de comprar uno nuevo
        </h2>
        <p className="text-base md:text-lg text-honey-900/75 mb-8 max-w-xl">
          Cuando se termine tu shampoo, acondicionador o gel corporal, vuelve a llenar tu botella con nuestras
          bolsas refill de 500ml o 1 litro. Mismo producto artesanal, menos residuos.
        </p>

        <ul className="space-y-5 mb-10">
          {BENEFITS.map(({ icon: Icon, title, text }) => (
            <li key={title} className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-2xl bg-white shadow-sm flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5 text-emerald-700" />
              </div>
              <div>
                <p className="font-semibold text-honey-950">{title}</p>
                <p className="text-sm text-honey-900/70">{text}</p>
              </div>
            </li>
          ))}
        </ul>

        <Button
          onClick={goToRefill}
          data-testid="refill-section-cta"
          className="group rounded-full bg-honey-600 hover:bg-honey-700 text-white px-8 py-6 text-base transition-colors"
        >
          Ver refills
          <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
        </Button>
      </div>
    </div>
  </section>
);
